export interface Position {
    id: number
    top: number
    left: number
}

export const positions: Position[] = [
    {
        id: 0,
        top: 80,
        left: 44
    },
    {
        id: 1,
        top: 69,
        left: 50
    },
    {
        id: 2,
        top: 64,
        left: 53
    },
    {
        id: 3,
        top: 58,
        left: 56
    },
    {
        id: 4,
        top: 54,
        left: 57
    },
    {
        id: 5,
        top: 48,
        left: 58
    },
    {
        id: 6,
        top: 46,
        left: 55
    },
    {
        id: 7,
        top: 44,
        left: 50
    },
    {
        id: 8,
        top: 42,
        left: 46
    },
    {
        id: 9,
        top: 38,
        left: 45
    },
    {
        id: 10,
        top: 34,
        left: 46
    },
    {
        id: 11,
        top: 31,
        left: 48
    },
    {
        id: 12,
        top: 28,
        left: 51
    },
    {
        id: 13,
        top: 24,
        left: 53
    },
]